export function calculatePercentage(part: number, total: number, digits = 0): string {
  return ((part / total) * 100).toFixed(digits);
}
